export const isViewerRole = (user) => user?.role === 'customer' || user?.role === 'demo';

export const homePath = (user) => {
  if (isViewerRole(user)) return '/portal';
  if (user?.role === 'admin' || user?.role === 'manager') return '/admin';
  return '/dashboard';
};
